<template>
  <div>
    <el-row type="flex" align="middle" justify="space-around" :gutter="10" style="width: 100%;height: 160px;">
      <el-card v-for="(item, index) in dashList" :key="index" style="width: 32%;height: 110px;" shadow="hover">
        <el-row type="flex" justify="space-between" align="top">
          {{ item.label }}:<em style="font-weight: bold;font-size: 50px;">{{ item.num }}</em>
          <i :class="item.icon"
            style="color: #983CC9;font-size: 50px;background-color:#f1f1f1;padding: 10px;margin-right: 10px;border-radius: 10px;"></i>
        </el-row>
      </el-card>
    </el-row>
    <h2 style="margin: 20px;padding-bottom: 20px;">统计表</h2>
    <el-form :inline="true" :model="leftForm" size="medium">
      <el-form-item label="时间区域">
        <el-date-picker value-format="yyyy-MM-dd" v-model="leftForm.timeZone" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" size="medium">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="省份" prop="province">
        <el-select v-model="leftForm.province" placeholder="请选择">
          <el-option v-for="item in provinceList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-select v-model="leftForm.unit" placeholder="请选择" @change="handleSelectChange" multiple style="width: 300px">
          <el-option v-if="!isAllSelected" label="全部" value="all"></el-option>
          <el-option v-if="isAllSelected" label="全部取消" value="removeAll"></el-option>
          <el-option v-for="item in hospitalList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大区">
        <el-select v-model="leftForm.region" style="width: 260px">
          <el-option label="东区" :value="0"></el-option>
          <el-option label="南区" :value="1"></el-option>
          <el-option label="西区" :value="2"></el-option>
          <el-option label="北区" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科室" prop="department_mide">
        <el-select v-model="leftForm.department_mide" placeholder="请选择">
          <el-option v-for="item in departmentList" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="小组" prop="group">
        <el-select v-model="leftForm.group" placeholder="请选择">
          <el-option v-for="item in groups" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台配置">
        <el-select multiple style="width: 80%" v-model="leftForm.access">
          <el-option label="网页" :value="0"></el-option>
          <el-option label="小程序" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="leftSubmit">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="leftReset">清空</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="exportExtcel">导出</el-button>
      </el-form-item>
    </el-form>
    <div style="padding:0 20px;">
      <el-table class="table1" :data="sortData" border style="width: 100%;margin-top: 10px;overflow-x: auto;"
        :header-cell-style="{ 'background-color': '#f6f6f6' }">
        <el-table-column align="center" prop="account" label="账号"></el-table-column>
        <el-table-column align="center" prop="region" label="大区"></el-table-column>
        <el-table-column align="center" prop="province" label="省份"></el-table-column>
        <el-table-column align="center" prop="unit" label="单位名称" width="130px"></el-table-column>
        <el-table-column align="center" prop="dept" label="科室"></el-table-column>
        <el-table-column align="center" prop="group" label="小组"></el-table-column>
        <el-table-column align="center" width="130px" label="平台配置">
          <template slot-scope="scope" >
            {{ getAccessText(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column sortable align="center" prop="conversation" label="会话数" width="130px"></el-table-column>
        <el-table-column sortable align="center" prop="question" label="提问数" width="130px"></el-table-column>
        <el-table-column sortable align="center" prop="num" label="使用时长" width="130px"></el-table-column>
        <!-- <el-table-column sortable align="center" prop="token" label="消耗token"></el-table-column> -->
        <el-table-column sortable align="center" prop="kimi_token" label="消耗kimi_token" width="150px"></el-table-column>
        <el-table-column sortable align="center" prop="db_token" label="消耗db_token" width="140px"></el-table-column>
        <el-table-column sortable align="center" prop="deepseek_token" label="消耗deepseek_token"
          width="190px"></el-table-column>
        <el-table-column sortable align="center" prop="qwen_token" label="消耗qwen_token" width="160px"></el-table-column>
      </el-table>
    </div>
    <el-pagination background :current-page="current_page" layout="prev, pager, next" :page-size="page_size"
      @current-change="change_page" @prev-click="change_page" @next-click="change_page" :page-count="total">
    </el-pagination>
    <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage1"
      :page-size="page_size"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination> -->
    <div style="height: 12vh"></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "data_statistics",
  data() {
    return {
      leftForm: {
        timeZone: '', "start_time": "",
        "end_time": "", region: '', province: '', unit: [], department_mide: '', group: '', access: [],
      },
      isAllSelected: false, // 用于控制“全部”选项的显示
      hospitalList: [
      ],
      departmentList: [],
      groups: [],
      provinceList: [
        "北京市", "天津市", "上海市", "重庆市",
        "河北省", "山西省", "辽宁省", "吉林省", "黑龙江省",
        "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省",
        "河南省", "湖北省", "湖南省", "广东省", "海南省",
        "四川省", "贵州省", "云南省", "陕西省", "甘肃省", "青海省",
        "台湾省",
        "内蒙古自治区", "广西壮族自治区", "西藏自治区", "宁夏回族自治区", "新疆维吾尔自治区",
        "香港特别行政区", "澳门特别行政区"
      ],
      sortData: [],
      dashList: [
        { field: 'user_count', label: "用户数", num: '', icon: 'el-icon-user-solid' },
        { field: 'conversation_count', label: "会话数", num: '', icon: 'el-icon-s-platform' },
        { field: 'question_count', label: "提问数", num: '', icon: 'el-icon-s-comment' },
        // {field: 'token_count', label: "token数", num: '', icon: 'el-icon-s-flag'},
      ],
      current_page: 1,
      page: 1,
      page_size: 10,
      total: 0,
    }
  },
  mounted() {
    this.getStaticData();
    axios.get("/api/admin/unit", { 
      headers: { 'Content-Type': 'application/json' } ,
      params: { page_size: 1000, page: 1 }
    }).then((res) => {
      if (res.data.code === 200) {
        for (let i = 0; i < res.data.data.length; i++) {
          const item = { label: res.data.data[i].name, value: res.data.data[i].name }
          this.hospitalList.push(item);
        }
      }
    })
    axios.get("/api/admin/department/mide", { headers: { 'Content-Type': 'application/json' } }).then((res) => {
      if (res.data.code === 200) {
        for (let i = 0; i < res.data.data.length; i++) {
          const item = { label: res.data.data[i].name, value: res.data.data[i].name }
          this.departmentList.push(item);
        }
      }
    })
    axios.get("/api/admin/group", { headers: { 'Content-Type': 'application/json' } }).then((res) => {
      if (res.data.code === 200) {
        for (let i = 0; i < res.data.data.length; i++) {
          const item = { label: res.data.data[i].name, value: res.data.data[i].name }
          this.groups.push(item);
        }
      }
    })
  },
  methods: {
    getAccessText(row) {
      let accessText = '';
      if (row.platform_access) accessText += '网页 ';
      if (row.small_program_access) accessText += '小程序 ';
      return accessText.trim();
    },
    handleSelectChange() {
      // 如果选中了“全部”，则选中所有选项
      if (this.leftForm.unit.includes("all")) {
        this.leftForm.unit = this.hospitalList.map((item) => item.value);
        this.isAllSelected = true; // 标记“全部”已选中
      }else if(this.leftForm.unit.includes("removeAll")) {
        // 如果选中了“全部取消”，则清空所有选项
        this.leftForm.unit = [];
        this.isAllSelected = false; // 标记“全部”已取消

      } else {
        // 如果取消了“全部”，则移除“全部”选项
        this.leftForm.unit = this.leftForm.unit.filter((item) => item !== "all");
        this.isAllSelected = false; // 取消标记
      }

      
    },


    leftSubmit() {
      this.page = 1; // 重置页码
      if (this.leftForm.timeZone !== '') {
        this.leftForm.start_time = this.leftForm.timeZone[0]
        this.leftForm.end_time = this.leftForm.timeZone[1]
      }
      const params = {
        page_size: this.page_size,
        ...this.leftForm,
        page: this.page,
        unit: this.leftForm.unit.join(','),
        access: this.leftForm.access.join(',')
      }

      axios.get('/api/admin/statistics', {
        params: params
      }).then(res => {
        const { data } = res
        if (data['code'] === 200) {
          this.sortData = res.data.data;
          // this.total = res.data['user_count'];
          this.total = res.data['total'];
        }
      })
    },
    leftReset() {
      this.page = 1;
      this.leftForm = {
        timeZone: '', "start_time": "",
        "end_time": "", region: '', province: '', unit: [], department_mide: '', group: '', "page": this.page, access: [],
        "page_size": this.page_size,
      },
        this.total = 0; // 重置总数
        this.getStaticData();
    },

    exportExtcel() {
      if (this.leftForm.timeZone !== '') {
        this.leftForm.start_time = this.leftForm.timeZone[0]
        this.leftForm.end_time = this.leftForm.timeZone[1]
      }
      const params = {
        page_size: this.page_size,
        ...this.leftForm,
        page: this.page,
        unit: this.leftForm.unit.join(','),
        access: this.leftForm.access.join(',')
      }
      axios.get("/api/admin/export/statistics", {
        params: params,
      }).then((res) => {
        
        if (res.data.code === 200) {
          
          const downloadUrl = "/api/static/export/" + res.data.name;

          
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = res.data.name; // 设置下载文件名
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a); // 下载完成后移除a标签
        }
      })


    },
    getStaticData() {

      if (this.leftForm.timeZone !== '') {
        this.leftForm.start_time = this.leftForm.timeZone[0]
        this.leftForm.end_time = this.leftForm.timeZone[1]
      }
      const params = {
        page_size: this.page_size,
        ...this.leftForm,
        page: this.page,
        unit: this.leftForm.unit.join(','),
        access: this.leftForm.access.join(',')
      }
      
      axios.get("/api/admin/statistics", {
        params: params
      }).then((res) => {
        if (res.data.code === 200) {
          for (let i = 0; i < this.dashList.length; i++) {
            let field = this.dashList[i].field;
            this.dashList[i].num = res.data[field];
          }
          this.sortData = res.data.data;
          // this.total = res.data['user_count'];
          this.total = res.data['total'];
          

        }
      })
    },
    change_page(page) {

      this.page = page
      this.getStaticData();
    },
  }
}
</script>

<style scoped>
.table1 ::-webkit-scrollbar {
  width: 11px !important;
  height: 11px !important;
}

  /* 限制多选标签容器的高度并添加滚动条 */
  ::v-deep .el-select__tags {
      max-width: 100% !important;
      max-height: 30px !important;
      overflow-y: auto !important;
    }
    /* 调整滚动条样式以提高可读性 */
    ::v-deep .el-select__tags::-webkit-scrollbar {
      width: 5px;
    }
    ::v-deep .el-select__tags::-webkit-scrollbar-thumb {
      background-color: #bfbfbf;
      border-radius: 10px;
    }
</style>